module.exports = __webpack_public_path__ + "media/images/guideline/H_03-9b70c2eea5ca2cafaa3638165c8937d3.jpg";